<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter">Contents</h1>
<p class="toc"><img alt="" src="OEBPS/images/6-1.jpg"/></p>
<p class="toc"><a class="hlink" href="#/OEBPS/int.htm">Introduction</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c01.htm"><strong>PROJECTS</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec1"><strong>The Bunny Bunch </strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec2"><strong>Bertie and Beatrice the Birds </strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec3"><strong>Frederick the Frog Prince</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec4"><strong>Babushkas</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec5"><strong>Three Hungry Bears</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec6"><strong>Polly Dolly’s Dress-up Day</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec7"><strong>Simon Snake</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec8"><strong>Piggies at Play</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec9"><strong>Mischievous Mice</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec10"><strong>Eddie the Friendly Elephant</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec11"><strong>Three Little Fish</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec12"><strong>Peter Penguin’s Fishing Trip</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm#sec13"><strong>The Owl and the Pussycat</strong></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c02.htm"><strong>TECHNIQUES</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec1"><strong>Abbreviations</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec2"><strong>Casting on</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec3"><strong>The knit and purl stitches</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec4"><strong>Basic stitch patterns</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec5"><strong>Binding off</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec6"><strong>Shaping</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec7"><strong>Knitting in the round</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec8"><strong>Colourwork</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec9"><strong>Making up</strong></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c02.htm#sec10"><strong>Finishing touches</strong></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/bm1.htm">Templates</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/bm2.htm">Yarns used</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/bm3.htm">Suppliers</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ata.htm">About the author</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ack.htm">Acknowledgments</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ind.htm">Index</a></p>
<p class="toc"><img alt="" src="OEBPS/images/6-2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?308bc8a1